import { call, put, takeLatest } from 'redux-saga/effects';

import { InsuranceTemplate } from '@models/InsuranceTemplate';
import { InsuranceTemplateApi } from '@apis/InsuranceTemplateApi';

import {
  insuranceTemplatesFetch,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleInsuranceTemplatesFetch() {
  const state: StateUpdatePayload = { templates: [] };
  try {
    state.templates = (yield call(InsuranceTemplateApi.getAll)) as InsuranceTemplate[];
    yield put(stateUpdate(state));
  } catch { }
}

export default function* () {
  yield takeLatest(insuranceTemplatesFetch, handleInsuranceTemplatesFetch);
}
